import axios from "axios";

export const BASE_URL = "https://unit61.smartekanban.in/index.php";

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/x-www-form-urlencoded" },
});

// Convert JSON → form data
const form = (obj) => {
  const f = new URLSearchParams();
  Object.entries(obj).forEach(([k, v]) => f.append(k, v));
  return f;
};

export const TLSApi = {

  getTlsLines: (suId) =>
    api.post("/Apiv7/get_tls_lines", form({ su_id: suId })),

  getItemsByLineDayReport: (lineNo) =>
    api.post("/Apiv7/get_item_no_for_report", form({ line_no: lineNo })),

  getTlsTimeSettings: () => api.get("/Apiv7/get_tls_time_settings"),

  getColorStyle: (lineNo, itemNo) =>
    api.post("/Apiv7/get_color_style", form({ line_no: lineNo, item_no: itemNo })),

  getTlsDayReport: (lineNo, itemNo, date) =>
    api.post("/Apiv7/tls_day_report", form({ line_no: lineNo, item_no: itemNo, date })),

  getQcReviews: (lineNo, itemNo, date) =>
    api.post("/Apiv7/get_qc_reviews", form({ line_no: lineNo, item_no: itemNo, date })),
   getItemsByLine: (lineNo) =>
    api.post("/Apiv7/get_item_no_for_report", form({ line_no: lineNo })),
    getTlsBoardReport: (lineNo, itemNo, date) =>
    api.post("/Apiv7/tls_day_report", form({ line_no: lineNo, item_no: itemNo, date })),

  getAllStaffUsers: (page, limit = 10) =>
  api.post("/Apiv6/get_all_staff_users", form({ page, limit })),



  updateStaffUser: (payload) =>
    api.post("/Apiv6/update_staff_user", form(payload)),
    
};
